import { config, ParallaxProvider } from '@adc/parallax-component-library';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { useColorScheme } from './features/settings/colorScheme';
import { useDevToolsSetting } from './features/settings/devTools';
import { routeTree } from './routeTree.gen';

declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router;
  }
}

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

export const Navigation = () => {
  const { isDevToolsEnabled } = useDevToolsSetting();
  const { colorScheme } = useColorScheme();

  return (
    <ParallaxProvider
      defaultTheme={colorScheme}
      dir="ltr"
      locale="en-US"
      config={config}
    >
      <RouterProvider router={router} />
      {isDevToolsEnabled ? (
        <TanStackRouterDevtools router={router} position="bottom-right" />
      ) : null}
    </ParallaxProvider>
  );
};
